import { Button, Modal, Table } from "react-bootstrap";
import { ProdutoNFCeDto } from "../NFCe.Dto";

export interface ProdutoConsultaProps {
  show: boolean;
  onHide: () => void;
  onSelect: (value: ProdutoNFCeDto) => void;
  data: ProdutoNFCeDto[];
}

export const NFCeModalItemConsulta = (props: ProdutoConsultaProps) => {
  return (
    <>
      <Modal show={props.show} centered fullscreen="xxl-down">
        <Modal.Body>
          {props.data && props.data.length > 0 && (
            <Table responsive hover>
              <thead>
                <tr>
                  <th className="col-xs-10 col-md-8">Nome</th>
                  <th className="d-none d-sm-table-cell col-02">Und</th>
                  <th className="col-2 text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                {props.data?.map((item) => (
                  <tr
                    key={item.id}
                    onClick={() => props.onSelect(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="col-xs-12 col-md-8">
                      {item.nome} {"[" + item.codigoProduto + "]"}
                    </td>
                    <td className="d-none d-sm-table-cell col-02">
                      {item.unidadeComercial}
                    </td>
                    <td className="col-2 text-end">
                      {item.valorUnitarioComercial.toFixed(2).replace(".", ",")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Voltar</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
